import { memo } from "react"
import styled from "styled-components/native"

const Spacer = styled.View<{ height?: string; width?: string; color?: string; flex?: number }>`
  ${({ height }) => (height ? `height: ${height};` : undefined)};
  ${({ width }) => (width ? `width: ${width};` : undefined)};
  ${({ flex }) => (flex ? `flex: ${flex};` : undefined)};
  background-color: ${({ color }) => color || "transparent"};
`

export default memo(Spacer)
